export const INCIDENT_IMPACT = {
    CRITICAL: 'critical',
    MAINTENANCE: 'maintenance',
    MAJOR: 'major',
    MINOR: 'minor',
    NONE: 'none'
};

export const INCIDENT_STATUS = {
    COMPLETED: 'completed',
    IDENTIFIED: 'identified',
    INPROGRESS: 'in_progress',
    INVESTIGATING: 'investigating',
    MONITORING: 'monitoring',
    RESOLVED: 'resolved',
    SCHEDULED: 'scheduled',
    VERIFYING: 'verifying'
};
